import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import BrandLogo from '../../../components/BrandLogo';

export default function LandingHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="w-full bg-white/80 backdrop-blur border-b border-gray-200 sticky top-0 z-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="shrink-0">
          <BrandLogo variant="careerlift" className="h-8" />
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-6 text-sm">
          <Link to="/#features" className="hover:underline transition-all duration-200">Features</Link>
          <Link to="/#roles" className="hover:underline transition-all duration-200">Roles</Link>
          <Link to="/#pricing" className="hover:underline transition-all duration-200">Pricing</Link>
          <Link to="/contact-page" className="hover:underline transition-all duration-200">Contact</Link>
          <Link 
            to="/authentication" 
            className="rounded-xl bg-primary text-white px-4 py-2 hover:bg-primary/90 transition-all duration-200 font-medium"
          >
            Start Free / Sign In
          </Link>
        </nav>

        {/* Mobile menu button */}
        <button 
          onClick={toggleMenu}
          className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors" 
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-1 space-y-3">
            <Link to="/#features" className="block py-2 text-sm hover:text-primary transition-colors">Features</Link>
            <Link to="/#roles" className="block py-2 text-sm hover:text-primary transition-colors">Roles</Link>
            <Link to="/#pricing" className="block py-2 text-sm hover:text-primary transition-colors">Pricing</Link>
            <Link to="/contact-page" className="block py-2 text-sm hover:text-primary transition-colors">Contact</Link>
            <Link 
              to="/authentication" 
              className="block w-full text-center rounded-xl bg-primary text-white px-4 py-3 hover:bg-primary/90 transition-all duration-200 font-medium mt-4"
            >
              Start Free / Sign In
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}